import { isSignal, signal, type Signal, type WritableSignal } from '@angular/core';

// Si el valor indicado es un signal, lo devuelve, si no, crea uno a partir de él
export const asSignal = <T>(value: T | null | undefined | Signal<T | null | undefined> | WritableSignal<T | null | undefined>): Signal<T | null | undefined> | WritableSignal<T | null | undefined> => {
  return isSignal(value) ? value : signal(value);
};
